export const DataLoadStatus = {
  PENDING: 'pending',
  IN_PROGRESS: 'in_progress',
  COMPLETE: 'complete',
};

export const DataLoadStatusRoute = {
  DATALOADSTATUS: 'dataloadstatus',
  NOTIFICATIONS: 'notificationrules',
  DATALOADSTATUS_NOTIFICATIONS: 'dataloadstatus/notificationrules',
};

export const DataLoadStatusPathName = {
  DATALOADSTATUS: 'dataloadstatus',
  DATALOADSTATUS_NOTIFICATIONS: 'dataloadstatus/notificationrules',
};

export const DataLoadTabValues = {
  NEEDS_ATTENTION: 'attention',
  DAILYDATALOAD: 'daily',
  CONNECTION_STATUS: 'connection',
  ASSIGNMENT_STATUS: 'assignment',
  NOTIFICATIONS: 'notifications',
};

export const DailyLoadCompleteState = {
  YES: 'yes',
  NO: 'no',
};

export const MappingStatus = {
  PENDING: 'pending',
  SUCCESS: 'success',
  CREDENTIAL: 'credential',
  OTHER: 'other',
};
